import React, { Component } from 'react';
import Wrapper from '../../wrapper/Wrapper';
import Burger from '../../stateless/burger/burger';
import BurgerControllers from '../../stateless/burger/burger-controller/burger-controller';
import Modal from '../../stateless/common/Modal/Modal';
import OrderSummary from '../../stateless/burger/OrderSummary/OrderSummary';
import Axios from '../../webservice/service';
import Spinner from '../../stateless/common/Spinner/Spinner';

import NotifyWrapper from '../../wrapper/NotifyWrapper';

import { connect } from 'react-redux';
import * as actionTypes from '../../redux-store/redux-actions/redux-actions';

// const INGREDIENT_PRICE = {
//     'salad' : 0.5,
//     'cheese' : 0.5,
//     'meat' : 2.4,
//     'bacon' : 0.6
// }

class Builder extends Component{

    state = {
        isSummayOpen : false,
        ordering : false
    }

    isPurchasable = () => {
        const object = {...this.props.ingredients};
        return Object.values(object).reduce((current,value) => {
            return current+value;
        }, 0 );
    }

    openSummary = () => {
        // const ingredientsQuery = this.props.ingredients;
        // let query = [];
        // for(let i in ingredientsQuery){
        //     query.push(encodeURIComponent(i)+'='+encodeURIComponent(ingredientsQuery[i]));
        // }
        // this.props.history.push({
        //     pathname:'/checkout',
        //     search:query.join('&')
        // });

        this.props.history.push('/checkout');
        // const value = this.state.isSummayOpen;
        // this.setState({isSummayOpen:!value});
    }

    // addIngredientsHandler = (type) => {
    //     const updatedCount = this.props.ingredients[type];
    //     const updated = updatedCount + 1;
    //     let updateIngredients = {...this.props.ingredients};
    //     updateIngredients[type] = updated;
    //     const priceTobeAdded = INGREDIENT_PRICE[type];
    //     const updatedPrice = this.props.totalPrice + priceTobeAdded;
    //     this.setState({ingredients:updateIngredients,totalPrice:updatedPrice});
    // }

    // rmIngredientsHandler = (type) => {
    //     const updatedCount = this.props.ingredients[type];
    //     const updated = updatedCount? updatedCount - 1 : 0;
    //     let updateIngredients = {...this.props.ingredients};
    //     updateIngredients[type] = updated;
    //     const priceTobeRemoved = INGREDIENT_PRICE[type];
    //     const updatedPrice = this.props.totalPrice - priceTobeRemoved;
    //     this.setState({ingredients:updateIngredients,totalPrice:updatedPrice});
    // }

    // saveOrder = () => {
    //     this.setState({ordering : true});
    //     const order = {
    //         ingredients : this.state.ingredients,
    //         price : this.state.totalPrice,
    //         customer : {
    //             name : 'NDK',
    //             address : {
    //                 street : 'myStreet',
    //                 zipcode : '5456621',
    //                 country : 'SEVEN KINGDOMS'
    //             },
    //             email : 'mylove@love.com',
    //             phone : '1234567891'
    //         }
    //     }
    //     Axios.post('/order.json',order)
    //     .then((response) => 
    //         {
    //             const value = this.props.isSummayOpen;
    //             this.setState({isSummayOpen:!value , ordering : false});
    //         })
    //     .catch(error => {console.log(error);
    //         const value = this.props.isSummayOpen;
    //         this.setState({isSummayOpen:!value , ordering : false});
    //     });
    // }

    render(){
        const shouldDisable = Object.assign({},this.props.ingredients);
        const updated = Object.keys(shouldDisable).map(shd => {
            return shouldDisable[shd] === 0;
        })

        const summaryOrSpinner =  !this.state.ordering ? 
            <OrderSummary ingredients={this.props.ingredients} 
                totalPrice = {this.props.totalPrice}
                openSummary={this.openSummary}
                order={this.saveOrder}></OrderSummary>
            : <Spinner></Spinner> ;

        return (
            <Wrapper>
                {this.state.isSummayOpen ? 
                    <Modal show={this.state.isSummayOpen} openSummary={this.openSummary}> 
                        {summaryOrSpinner} 
                    </Modal> 
                    : null }
                <Burger ingredients={this.props.ingredients}/>
                <BurgerControllers handler={this.props.addIngredientsHandler}
                rmHandler = {this.props.rmIngredientsHandler}
                disable = {updated}
                price = {this.props.totalPrice}
                isPurchasable = {this.isPurchasable()}
                modalSummary = {this.openSummary}/>
            </Wrapper>
        );
    }
}

const linkGlobalStore = (state) => {
    return {
        ...state.Reducer
    }
}

const linkDispatchtoProps = (dispatch) => {
    return {
        addIngredientsHandler : (type) => dispatch(actionTypes.addIngredients(type)),
        rmIngredientsHandler : (type) => dispatch(actionTypes.removeIngredients(type))
    };
}

export default connect(linkGlobalStore,linkDispatchtoProps)(NotifyWrapper(Builder, Axios));